import { render } from "./yi-qxc.vue?vue&type=template&id=1fdad7f6&scoped=true"
import script from "./yi-qxc.vue?vue&type=script&lang=js"
export * from "./yi-qxc.vue?vue&type=script&lang=js"

import "./yi-qxc.vue?vue&type=style&index=0&id=1fdad7f6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdad7f6"]])

export default __exports__